import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Costume, Performance } from '../model/recital';

export interface UpdatePerformanceParams {
  actId: string;
  performanceId: string;
  name?: string;
  description?: string;
  classIds?: Array<string>;
  studentIds?: Array<string>;
  orderIndex?: number;
  duration?: number;
  costume?: Costume;
}

export const updatePerformanceAPI = async ({
  actId,
  performanceId,
  ...params
}: UpdatePerformanceParams) => {
  const response = await baseAPI.patch<Performance>(
    `/acts/${actId}/performances/${performanceId}`,
    params,
  );
  return response.data;
};

export const useUpdatePerformanceMutation = () => {
  return useMutation({
    mutationFn: async (params: UpdatePerformanceParams) => {
      return await updatePerformanceAPI(params);
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACTS, variables.actId, KEYS.PERFORMANCES],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PERFORMANCES, variables.performanceId],
      });
    },
  });
};
